import { useGetAvailableCities } from '@/newCargoPickUpPage/hooks/useGetAvailableCities';
import { CalculatePage, CargoPickupPage, ForwardinReceiptPage } from '@/pages';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';
import { onMounted, provide, ref } from 'vue';
import { RouterLink } from 'vue-router';

export default {
  name: 'App',
  components: {
    CargoPickupPage,
    CalculatePage,
    ForwardinReceiptPage,
    RouterLink,
  },

  setup() {
    const dataForm = useNewDataFormCargoPickUpStore();
    const citiesArr = ref([]);

    const citiesPickup = useGetAvailableCities('acceptanceCargo');
    const citiesDelivery = useGetAvailableCities('issuanceOfCargo');

    provide('citiesArr', citiesArr);
    provide('citiesPickup', citiesPickup);
    provide('citiesDelivery', citiesDelivery);

    onMounted(async function () {});
    return { dataForm };
  },
};
